import { cn } from '@/lib/utils'
import { BodyText, HeadlineText } from 'design-configuration/components'

export function LiveSaleDataDisplay({
  value,
  label,
  className,
  isPrice
}: {
  value: React.ReactNode
  label: string
  isPrice?: boolean
  className?: string
}): React.ReactElement {
  return (
    <div className={className}>
      <HeadlineText
        className={cn('font-medium', {
          'gap-2xs flex items-end': isPrice
        })}
        asChild
      >
        <p>
          <span>{value}</span>
          {isPrice ? <span className="relative -top-[5px] text-lg">Ξ</span> : null}
        </p>
      </HeadlineText>
      <BodyText className="text-on-surface-variant">{label}</BodyText>
    </div>
  )
}
